/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PasswordReset_viewer$ref = any;
export type routes_PasswordReset_QueryVariables = {|
  token: string
|};
export type routes_PasswordReset_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: PasswordReset_viewer$ref
  |}
|};
export type routes_PasswordReset_Query = {|
  variables: routes_PasswordReset_QueryVariables,
  response: routes_PasswordReset_QueryResponse,
|};
*/


/*
query routes_PasswordReset_Query(
  $token: String!
) {
  viewer {
    ...PasswordReset_viewer
    id
  }
}

fragment PasswordReset_viewer on Customer {
  canResetPassword(passwordResetToken: $token)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_PasswordReset_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PasswordReset_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_PasswordReset_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "passwordResetToken",
                "variableName": "token"
              }
            ],
            "kind": "ScalarField",
            "name": "canResetPassword",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d2449563072cbd5ab2fee7db0d5fec20",
    "id": null,
    "metadata": {},
    "name": "routes_PasswordReset_Query",
    "operationKind": "query",
    "text": "query routes_PasswordReset_Query(\n  $token: String!\n) {\n  viewer {\n    ...PasswordReset_viewer\n    id\n  }\n}\n\nfragment PasswordReset_viewer on Customer {\n  canResetPassword(passwordResetToken: $token)\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3f66f77c0978743607ef05fce44b1ea1';

module.exports = node;
